// extracted by mini-css-extract-plugin
export default {"groupHeader":"MWOJRfuH3Q","groupHeader_noBorder":"ut3AmRvjLn"};